// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"fabdf2fe","146":"5099aa60","208":"4ce14b79","673":"eccb7d7b","841":"93b2ca89"}[chunkId] + ".chunk.js";
};